import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, rolesAllowed = [] }) => {
  const token = sessionStorage.getItem('token');
  const role = sessionStorage.getItem('role');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (rolesAllowed.length > 0 && !rolesAllowed.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;